import { useSelector, useDispatch } from "react-redux";
import {
  clearHomeLastScrollY,
  clearHomeListingPageScrollX,
  setHomeLastScrollY,
  setHomeListingPageScrollX,
} from "@actions/navigation-actions";

export function useHomeLastScrollY() {
  return useSelector((state) => state.navigation.home.lastScrollY);
}

export function useSetHomeLastScrollY() {
  const dispatch = useDispatch();

  return (lastScrollY) => dispatch(setHomeLastScrollY(lastScrollY));
}

export function useClearHomeLastScrollY() {
  const dispatch = useDispatch();

  return () => dispatch(clearHomeLastScrollY());
}

export function useHomeLastScrollX(listingSlug) {
  const homeNavigation = useSelector((state) => state.navigation.home);

  if (!listingSlug || !homeNavigation[listingSlug]) return 0;

  return homeNavigation[listingSlug].lastScrollX;
}

export function useSetHomeListingPageLastScrollX() {
  const dispatch = useDispatch();

  return (lastScrollX, listingSlug) => dispatch(
    setHomeListingPageScrollX(lastScrollX, listingSlug),
  );
}

export function useClearHomeListingPageLastScrollX() {
  const dispatch = useDispatch();

  return (listingSlug) => dispatch(clearHomeListingPageScrollX(listingSlug));
}
